<template>
  <div class="list-group list-group-bordered" ref="list">
    <div class="list-group-header d-flex align-items-center"
         :class="{ 'justify-content-between': extraSmall || small, 'flex-column': extraSmall || small }"
         v-if="showHeader">
        <span :class="{ 'mb-2': extraSmall || small }">{{ authors.length }} {{
            authors.length === 1 ? 'Autor' : 'Autores'
                                                       }} agregados</span>
      <div :class="{ 'ml-auto': !extraSmall && !small }">
        <div class="d-inline-block">
          <button type="button"
                  class="btn btn-light"
                  title="Invitar autor"
                  @click="$emit('add-author')">
            <i class="fas fa-user-plus mr-2"></i> Agregar autor
          </button>
        </div>
        <div class="d-inline-block">
          <button type="button"
                  class="btn btn-light"
                  title="Invitar autor externo"
                  @click="$emit('add-external-author')">
            <i class="fas fa-user-plus mr-2"></i> Agregar autor externo
          </button>
        </div>
      </div>
    </div>
    
    <div v-if="authors && authors.length">
      <div class="list-group-item"
          v-for="author in authors"
          :data-id="author.id"
          :key="author.id">
        
        <div class="list-group-item-figure align-items-start">
          <a href="#" class="user-avatar">
            <img :src="author.avatar"
                :alt="author.full_name">
          </a>
        </div>
        
        <div class="list-group-item-body">
          <h4 class="list-group-item-title">
            <a href="#">{{ author.full_name }}</a>
          </h4>
          <p class="list-group-item-text"> {{ 'Investigador' }} </p>
          <div class="my-2">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio"
                     :data-id="author.id"
                     :id="'main-' + author.id"
                     :name="'participation-type-' + author.id"
                     class="custom-control-input participation-type-radio"
                     value="principal"
                     :checked="author.participation_type && author.participation_type === 'principal'">
              <label class="custom-control-label font-weight-light"
                     :for="'main-' + author.id">Principal</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio"
                     :data-id="author.id"
                     :id="'main-insp-' + author.id"
                     :name="'participation-type-' + author.id"
                     class="custom-control-input participation-type-radio"
                     value="principal_insp"
                     :checked="author.participation_type && author.participation_type === 'principal_insp'">
              <label class="custom-control-label font-weight-light"
                     :for="'main-insp-' + author.id">Principal Interno INSP</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio"
                     :data-id="author.id"
                     :id="'co-author-' + author.id"
                     :name="'participation-type-' + author.id"
                     class="custom-control-input participation-type-radio"
                     value="coautor"
                     :checked="author.participation_type && author.participation_type === 'coautor'">
              <label class="custom-control-label font-weight-light"
                     :for="'co-author-' + author.id">Coautor</label>
            </div>
            <div v-if="!hideCorrespondence"
                 class="custom-control custom-radio custom-control-inline">
              <input type="radio"
                     :data-id="author.id"
                     :id="'correspondence-' + author.id"
                     :name="'participation-type-' + author.id"
                     class="custom-control-input participation-type-radio"
                     value="correspondencia"
                     :checked="author.participation_type && author.participation_type === 'correspondencia'">
              <label class="custom-control-label font-weight-light"
                     :for="'correspondence-' + author.id">Correspondencia</label>
            </div>
          </div>
        </div>
        
        <div class="list-group-item-figure align-items-start" v-if="showActions">
          <div class="dropdown">
            <button class="btn btn-sm btn-icon btn-light"
                    data-toggle="dropdown"><i
              class="fa fa-fw fa-ellipsis-v"></i></button>
            <div class="dropdown-menu dropdown-menu-right">
              <div class="dropdown-arrow mr-n1"></div>
              <button type="button"
                      class="dropdown-item"
                      @click="$emit('delete-author', author.id)"
                      ref="btn-resend-invitation">Eliminar autor
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  
  export default {
    name: 'AuthorsList',
    props: {
      authors: {
        type: Array,
        default: () => ([]),
      },
      protocol: {
        type: Object,
        default: null,
      },
      showHeader: {
        type: Boolean,
        default: true,
      },
      showActions: {
        type: Boolean,
        default: true,
      },
      hideCorrespondence: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      resendingInvitation: false,
      cancelingInvitation: false,
    }),
    methods: {
      ...mapActions({
        resendInvitationNotification: 'protocols/resendInvitationNotification',
        removeResearcher: 'protocols/removeResearcher',
      }),
    },
    computed: {
      extraSmall() {
        return this.$mq === 'xs'
      },
      small() {
        return this.$mq === 'sm'
      },
    },
  }
</script>
